import React from "react"

import QrValidatorState from "../interfaces/QrValidatorState"
import RequestHandler from "../../../services/RequestHandler"

import {
    DEFAULT_VALIDATION_MESSAGE,
    SUCCESS_VALIDATION_MESSAGE,
    VALIDATION_MESSAGES,
    ValidationInfo,
} from "../interfaces/QrValidationConstants"

import qrFounded from "../assets/images/QrFounded.webp"
import qrExpired from "../assets/images/QrExpired.webp"
import qrNotFounded from "../assets/images/QrNotFounded.webp"

export default class QrValidatorController {
    protected state: QrValidatorState
    protected setState: React.Dispatch<React.SetStateAction<QrValidatorState>>

    constructor(
        state: QrValidatorState,
        setState: React.Dispatch<React.SetStateAction<QrValidatorState>>
    ) {
        this.state = state
        this.setState = setState
    }

    async init(url: string) {
        try {
            const validation = await this.checkBarcode(url)

            if (!validation) {
                this.updateState({
                    loading: false,
                    found: false,
                    availability: false,
                    image: qrNotFounded,
                    color: "#991118",
                    title: DEFAULT_VALIDATION_MESSAGE,
                })

                return
            }

            const { availability, found, status } = validation.data

            const { title, image , color } = this.getValidateInfo(
                availability,
                found,
                status
            )

            this.updateState({
                loading: false,
                availability,
                found,
                status,
                title,
                color,
                image,
            })
        } catch (error) {
            console.error(error)

            this.updateState({
                loading: false,
                found: false,
                availability: false,
                image: qrNotFounded,
                color: "#991118",
                title: DEFAULT_VALIDATION_MESSAGE,
            })
        }
    }

    async checkBarcode(url: string) {
        return await RequestHandler.get(url)
    }

    private getValidateInfo(
        availability?: boolean,
        found?: boolean,
        status?: QrValidatorState["status"]
    ): {
        title: ValidationInfo
        image: string
        color:string
    } {
        if (availability) {
            return {
                title: SUCCESS_VALIDATION_MESSAGE,
                image: qrFounded,
                color: "#22c55e"
            }
        }

        if (found && status) {
            return {
                title: VALIDATION_MESSAGES[status],
                image: qrExpired,
                color: "#fcb335"
            }
        }

        return {
            title: DEFAULT_VALIDATION_MESSAGE,
            image: qrNotFounded,
            color: "#991118"
        }
    }

    private updateState(state: Partial<QrValidatorState>) {
        const newState = {
            ...this.state,
            ...state,
        }

        this.state = newState
        this.setState(newState)
    }
}